<template>
  <BaseSkeleton
    v-if="isLoading"
    :type="skeleton ? skeleton : 'text'"
    :class="classes"
    v-bind="$attrs"
  />
  <component
    :is="tag"
    v-else
    class="base-text"
    :class="classes"
    v-bind="$attrs"
  >
    <slot />
  </component>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import BaseComponent from '../BaseComponent/BaseComponent.vue';
import BaseSkeleton from '@/shared/lib/uikit/components/BaseSkeleton/BaseSkeleton.vue';

export default defineComponent({
  name: 'BaseText',
  components: { BaseSkeleton },
  extends: BaseComponent,
  props: {
    tag: {
      type: String,
      default: 'span',
    },
  },
});
</script>

<style lang="scss" scoped>
@if mixin-exists("ThemeBaseText") {
  @include ThemeBaseText;
}
</style>
